var _path, _rect, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSmoke(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3516 19.9004L29.3159 20.9563C31.5059 21.2467 33.0458 23.2575 32.7554 25.4475C32.4651 27.6374 30.4544 29.1775 28.2644 28.8872L20.3029 27.8317L21.3516 19.9004Z",
    fill: "#E7DFD3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.50586,
    y: 18.0649,
    width: 22.1562,
    height: 8,
    rx: 4,
    transform: "rotate(7.55232 7.50586 18.0649)",
    fill: "#D9C7AD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.22427,
    cy: 22.2242,
    r: 4,
    transform: "rotate(-22.4477 9.22427 22.2242)",
    fill: "#FF5959"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 14,
    r: 3,
    fill: "#AAAAAC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 5,
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmoke);
export default __webpack_public_path__ + "static/media/ic_smoke.9a71c543861e92b7901732f8bb4b8b43.svg";
export { ForwardRef as ReactComponent };